// src/actions/LogisticsActions.js
import { createShipmentApi, trackShipmentApi, shippingStatusApi } from "../ENV";
import { fetchApi } from "./FetchAPI";

// Create shipment after payment
export async function createShipment(orderId, address) {
  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  };

  const body = JSON.stringify({
    order_id: orderId,
    address,
  });

  const res = await fetchApi(createShipmentApi, "POST", body, headerValue, {});
  return res.data;
}

// Track shipment
export async function trackShipment(shipmentId) {
  const headerValue = {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  };

  const res = await fetchApi(
    `${trackShipmentApi}/${shipmentId}`,
    "GET",
    "",
    headerValue,
    {}
  );
  return res.data;
}

// Fetch shipping status for a given form/order
export async function fetchShippingStatus(formId) {
  const headerValue = {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  };

  const res = await fetchApi(
    `${shippingStatusApi}/${formId}/shipping-status`,
    "GET",
    "",
    headerValue,
    {}
  );
  return res;
}
